import React, { useEffect, useCallback } from "react";
import "./EvidenceModal.css";

function EvidenceModal({ isOpen, sources, alt, onClose }) {
    const [index, setIndex] = React.useState(0);

    useEffect(() => {
        if (isOpen) setIndex(0);
    }, [isOpen, sources]);

    const hasMany = sources && sources.length > 1;
    const current = sources && sources.length ? sources[Math.min(index, sources.length - 1)] : null;

    const onKeyDown = useCallback(
        (e) => {
            if (!isOpen) return;
            if (e.key === "Escape") onClose();
            if (hasMany && e.key === "ArrowLeft") setIndex((i) => (i - 1 + sources.length) % sources.length);
            if (hasMany && e.key === "ArrowRight") setIndex((i) => (i + 1) % sources.length);
        },
        [isOpen, onClose, hasMany, sources]
    );

    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [onKeyDown]);

    if (!isOpen || !current) return null;

    return (
        <div
            className="evidence-modal-backdrop"
            role="dialog"
            aria-modal="true"
            aria-label="Certificate or photo preview"
            onClick={onClose}
        >
            <div className="evidence-modal-panel" onClick={(e) => e.stopPropagation()}>
                <button type="button" className="evidence-modal-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
                <img src={current} alt={alt || "Evidence"} className="evidence-modal-img" />
                {hasMany && (
                    <div className="evidence-modal-nav">
                        <button type="button" onClick={() => setIndex((i) => (i - 1 + sources.length) % sources.length)}>
                            ← Prev
                        </button>
                        <span>
                            {index + 1} / {sources.length}
                        </span>
                        <button type="button" onClick={() => setIndex((i) => (i + 1) % sources.length)}>
                            Next →
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default EvidenceModal;
